// Re-export service types from centralized services data
export { SERVICE_TYPES, type ServiceType } from "./services-data";

export const BUDGET_RANGES = [
  "Under £1,000",
  "£1,000 - £2,500",
  "£2,500 - £5,000",
  "£5,000 - £10,000",
  "£10,000+",
] as const;

export type BudgetRange = typeof BUDGET_RANGES[number];

// Toggle visibility of phone & WhatsApp contact methods across the site
export const SHOW_PHONE_CONTACT = true;

// Centralized contact information
export const CONTACT_INFO = {
  email: "himilostudio@gmail.com",
  phone: "+44 (0) 7960 207 356",
  phoneRaw: "+447960207356",
  whatsappLink: "https://wa.me/447960207356",
  location: "United Kingdom",
  socials: {
    instagram: "https://www.instagram.com/himilostudiolondon",
    snapchat: "https://www.snapchat.com/@himilostudio",
    tiktok: "https://www.tiktok.com/@himilostudio",
    youtube: "https://www.youtube.com/@HimiloStudio",
  },
} as const;
